import React, { useEffect, useState } from "react";
import { Switch } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import AbilityStatus from "../../order/AbilityStatus";
import CustomerStatus from "../../order/CustomerStatus";
import { customerConfig } from "../../../customerConfig";
import moment from "moment";
import { CustomerAssignAccountManagerModal } from "./CustomerAssignAccountManagerModal";
import useCustomers from "../../../hooks/useCustomers";
import { MdEdit } from "react-icons/md";
import { CustomerDetailEditModal } from "./CustomerDetailEditModal";
import updateFullPrivilege from "../../../controllers/Auth/fullPrivilege";

function CustomerDetailProfileSection({ data, callback }) {
  const { getCustomerSubscription } = useCustomers();
  const [accountManagerModal, setAccountManagerModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [subscription, setSubscription] = useState({});
  const [loading, setLoading] = useState(false);
  const [hasFullPrivilege, setHasFullPrivilege] = useState(
    Boolean(data?.hasFullPrivilege),
  );
  const [privilegeLoading, setPrivilegeLoading] = useState(false);
  const accountManager = [
    data?.detail?.accountManager?.firstName,
    data?.detail?.accountManager?.lastName,
  ]
    ?.filter((nm) => Boolean(nm))
    .join(" ");

  const loadData = async () => {
    await getCustomerSubscription({
      setLoading,
      id: data?._id,
      callback: (sub) => setSubscription(sub),
    });
  };
  useEffect(() => {
    loadData();
  }, [data]);

  useEffect(() => {
    setHasFullPrivilege(Boolean(data?.hasFullPrivilege));
  }, [data?.hasFullPrivilege, data?._id]);

  const handleFullPrivilegeToggle = async (checked) => {
    if (!data?._id) return;
    setPrivilegeLoading(true);
    const res = await updateFullPrivilege(data._id, {
      hasFullPrivilege: checked,
    });
    setPrivilegeLoading(false);
    if (res.return) {
      setHasFullPrivilege(checked);
      enqueueSnackbar("Full privilege updated", { variant: "success" });
      callback?.();
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
    }
  };

  const content = [
    {
      label: "ID",
      content: data?.reference || data?._id,
    },
    {
      label: "Company Name",
      content: data?.detail?.agencyName,
      editable: true,
      action: () => {
        setEditModal(true);
      },
    },
    {
      label: "Contact Person",
      content: [data?.firstName, data?.lastName]
        ?.filter((name) => Boolean(name))
        .join(" "),
      editable: true,
      action: () => {
        setEditModal(true);
      },
    },
    {
      label: "Email",
      content: data?.email,
      editable: true,
      action: () => {
        setEditModal(true);
      },
    },
    {
      label: "Phone Number",
      content: `+${data?.phone}`,
      editable: true,
      action: () => {
        setEditModal(true);
      },
    },
    {
      label: "Address",
      content: data?.detail?.address?.businessLocation,
      editable: true,
      action: () => {
        setEditModal(true);
      },
    },
    {
      label: "Account Manager",
      content: accountManager || "----------------",
      action: () => {
        setAccountManagerModal(true);
      },
    },
    {
      label: "Business Status",
      content: (
        <CustomerStatus
          value={
            data?.detail?.isVerified
              ? customerConfig.filterTabs.verified.code
              : data?.detail?.requestedVerification
                ? customerConfig.filterTabs.awaitingVerification.code
                : customerConfig.filterTabs.notSubmitted.code
          }
        />
      ),
    },
    {
      label: "Account Status",
      content: <AbilityStatus value={data?.accountStatus} />,
    },
    {
      label: "Subscription Status",
      content: loading ? (
        <div className="primaryLoader"></div>
      ) : (
        <AbilityStatus
          value={subscription?.isSubscriptionActive ? "Active" : "Inactive"}
        />
      ),
    },
    {
      label: "Sabre Full Access",
      content: (
        <Switch
          checked={hasFullPrivilege}
          color="primary"
          disabled={privilegeLoading}
          onChange={(e) => handleFullPrivilegeToggle(e.target.checked)}
        />
      ),
    },
    {
      label: "Plan",
      content: "----------------",
    },
    {
      label: "Wallet Balance",
      content: "----------------",
    },
    {
      label: "Date Registered",
      content: moment(data?.createdAt).format("DD MMM, YYYY"),
    },
    {
      label: "Last Login",
      content: moment(data?.pinEntry?.passwordExpiry).format("DD MMM, YYYY"),
    },
  ];

  return (
    <div className="p-4 flex w-full flex-col">
      <CustomerAssignAccountManagerModal
        open={accountManagerModal}
        setOpen={setAccountManagerModal}
        data={data}
        callback={callback}
      />
      <CustomerDetailEditModal
        open={editModal}
        setOpen={setEditModal}
        data={data}
        callback={callback}
      />
      {content?.map((item, itemIndex) => (
        <div className="w-full flex border-b py-2 gap-4" key={itemIndex}>
          <span className="w-32 lg:w-44 text-[#6D7C94] text-xs lg:text-sm">
            {item?.label}
          </span>
          <span className="text-xs lg:text-sm flex flex-1">{item.content}</span>
          {item?.editable ? (
            <button
              className="text-xs text-white bg-black px-2 py-1 rounded-md"
              onClick={() => item?.action?.()}
            >
              <MdEdit />
            </button>
          ) : item?.action ? (
            <button
              className="text-xs text-white bg-black px-2 py-1 rounded-md"
              onClick={item.action}
            >
              Change
            </button>
          ) : (
            <></>
          )}
        </div>
      ))}
    </div>
  );
}

export default CustomerDetailProfileSection;
